import { registerPlugin } from '@capacitor/core';
import { INativeDeviceStats } from '@monorepo/types';

export interface DeviceStatsPlugin {
  getDeviceStats(): Promise<INativeDeviceStats>;
}

export const DeviceStats = registerPlugin<DeviceStatsPlugin>('DeviceStats');
